import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowBackIosNewIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_back_ios_new"}/>
}
